import React from "react";
import "../Sidebar/sidebar.css";

const Sidebar = ({ isSidebarOpen, toggleSidebar }) => {
  return (
    <>
      <div
        className={`hamburger-icon ${isSidebarOpen ? "open" : ""}`}
        onClick={toggleSidebar}
      >
        <div className="hamburger-inner"></div>
        <div className="hamburger-inner"></div>
        <div className="hamburger-inner"></div>
      </div>

      {isSidebarOpen && (
        <div className="sidebar">
          <button className="close-btn" onClick={toggleSidebar}>
            &times;
          </button>
          <div className="sidebar-content">
            <img
              src="/Assests/Logo.png"
              alt="Sri Takshashila Gurukul"
              className="sidebar-logo"
            />
            <h3>Sri Takshashila Gurukul</h3>
            <p>
              Sri Takshashila Gurukul is committed to providing an enriching educational roadmap for children, helping them achieve their academic goals and beyond.


            </p>
            <h4>Contact Info</h4>
            <ul className="contact-info">
              <li>
                <i className="fa fa-phone"></i> +91 63616 64811
              </li>
              <li>
                <i className="fa fa-whatsapp"></i> +91 63616 64811
              </li>
              <li>
                <i className="fa fa-envelope"></i> sritakshashila@gmail.com
              </li>
            </ul>
          </div>
        </div>
      )}
    </>
  );
};

export default Sidebar;
